import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SeismicPartyDto, ContractorDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
    selector: 'cradua-seismicparty',
  templateUrl: './seismicparty.component.html',
  styleUrls: ['./seismicparty.component.scss']
})
export class SeismicPartyComponent implements OnInit {

  @Input() seismicpartys: SeismicPartyDto[];
  @Input() contractors: ContractorDto[];
  seismicpartyForm: FormGroup;
  seismicpartyFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<SeismicPartyDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredSeismicParty: Array<any> = [];
  status: boolean;
  selectedPartyChiefId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.createSeismicPartyForm();
  }

  createSeismicPartyForm() {
    this.seismicpartyFormArray = this.fb.group({ SeismicPartys: this.fb.array([]) });
    this.seismicpartyForm = this.fb.group({
      PartyChiefName: ['', Validators.required],
        ContractorId: this.selectedPartyChiefId,
        id: null
    });
  }


  // method to display companies
  setSeismicParty() {
    const control = this.seismicpartyFormArray.controls.SeismicPartys as FormArray;
    this.filteredSeismicParty.forEach((e) => {
      control.push(
        this.fb.group({
          PartyChiefName: e.PartyChiefName,
          ContractorId: e.ContractorId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addSeismicParty(seismicparty: SeismicPartyDto) {
    console.log('seismicparty');
    const control = this.seismicpartyFormArray.controls.SeismicPartys as FormArray;
    control.insert(
      0,
      this.fb.group({
        PartyChiefName: seismicparty.PartyChiefName,
        ContractorId: this.selectedPartyChiefId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.seismicpartyFormArray.controls.SeismicPartys as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter seismicparty
  selectContractor(event: string) {
    this.filteredSeismicParty = this.seismicpartys.filter((s) => s.ContractorId === event);
    this.selectedPartyChiefId = event;
    const control = this.seismicpartyFormArray.controls.SeismicPartys as FormArray;

    if (this.filteredSeismicParty.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setSeismicParty();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteSeismicParty(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.seismicpartyFormArray.controls.SeismicPartys as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.seismicpartys.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.seismicpartys[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: SeismicPartyDto) {
    if(this.seismicpartyForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.seismicpartyFormArray.get('SeismicPartys')['controls'][this.selectedIndex].patchValue({PartyChiefName: formValue.PartyChiefName});
    } else {
      this.addSeismicParty(formValue);
    }
    this.selectedIndex = null;
    this.seismicpartyForm.reset()
  }

  onEdit(index, value: SeismicPartyDto) {
    this.selectedIndex = index;
    this.seismicpartyForm.patchValue({PartyChiefName: value.PartyChiefName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.seismicpartyForm.reset();
  }


  onSubmit(formValue: any) {
    formValue.type = 'seismicparty';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('seismicparty');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
